export enum EOriginalContractAvailability {
  "ABSENT" = "absent",
  "IN_STOCK" = "in_stock",
  "WIHOUT_DOCUMENTS" = "without_documents",
}
